import { Button, Typography } from '@mui/material'
import { styled } from '@mui/system'
import AddIcon from '@mui/icons-material/Add'

import noPhotoImg from '../../assets/images/no-photo-illustration.svg'

import { useTranslation } from 'react-i18next'

const NoPhotoPlaceholder = styled('img')(({ theme }) => ({
  marginBottom: theme.spacing(1),
}))

const AddPhotoText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(1.5),
}))

const AddPhotoButtonWrapper = styled('label')(({ theme }) => ({
  position: 'absolute',
  bottom: theme.spacing(2),
}))

const AddPhotoButton = styled(Button)(({ theme }) => ({
  borderWidth: '2px !important',
  borderColor: theme.palette.primary.main,
  textTransform: 'uppercase',
}))

const NoPhoto = ({
  inRoute,
  sideText,
}: {
  inRoute?: boolean
  sideText: string
}) => {
  const { t } = useTranslation()
  return (
    <>
      <NoPhotoPlaceholder src={noPhotoImg} alt={t('alt.no_photo')} />
      <AddPhotoText variant="h1" component="p">
        {t('vehicle_photos.no_recent_photos')}
      </AddPhotoText>
      <Typography variant="body1" color="textSecondary">
        {sideText}
      </Typography>
      <AddPhotoButtonWrapper
        component="label"
        htmlFor={!inRoute && 'upload-photo-img'}
      >
        <AddPhotoButton
          variant="outlined"
          component="div"
          color="primary"
          disabled={inRoute}
          startIcon={<AddIcon />}
        >
          {t('vehicle_photos.add_photo')}
        </AddPhotoButton>
      </AddPhotoButtonWrapper>
    </>
  )
}

export default NoPhoto
